export const onlyDigits = (value = "") =>
  String(value ?? "").replace(/\D/g, "");

export const formatPhoneMx = (value = "") => {
  const digits = onlyDigits(value).slice(0, 10);
  if (!digits) return "";
  const a = digits.slice(0, 3);
  const b = digits.slice(3, 4);
  const c = digits.slice(4, 6);
  const d = digits.slice(6, 8);
  const e = digits.slice(8, 10);

  let out = "";
  if (a) out += `(${a}`;
  if (a.length === 3) out += ")";
  if (b) out += ` ${b}`;
  if (c) out += `-${c}`;
  if (d) out += `-${d}`;
  if (e) out += `-${e}`;
  return out;
};

export const isValidPhoneMx = (value = "") => onlyDigits(value).length === 10;

export const normalizeEmail = (value = "") => String(value ?? "").trim();

// Pragmatic and strict-enough app-level email validation
export const isValidEmail = (value = "") =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(normalizeEmail(value));
